var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0504 12.8787L15.7073 18.5355C16.4883 19.3166 17.7546 19.3166 18.5357 18.5355V18.5355C19.3167 17.7545 19.3167 16.4881 18.5357 15.7071L12.8788 10.0502C11.3167 8.48814 8.78408 8.48814 7.22198 10.0502V10.0502C5.65988 11.6123 5.65988 14.145 7.22198 15.7071L12.8788 21.3639C15.222 23.7071 19.021 23.7071 21.3641 21.3639V21.3639C23.7073 19.0208 23.7073 15.2218 21.3641 12.8787L17.8286 9.34313",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.ef6a001c038d7749cc408ca6e463fc06.svg";
export { ForwardRef as ReactComponent };